module.exports = __webpack_public_path__ + "static/media/mri-top-bg.a19c2616.mp4";